/** @jsx jsx */
import ReCAPTCHA from 'react-google-recaptcha';
import { useEffect } from 'react';

import { Colors } from '@zapier/theme';
import { css, jsx, Interpolation } from '@emotion/core';

type CaptchaProps = {
  googleCaptchaSiteKey: string;
  onCaptchaExpiration: () => void;
  onCaptchaVerification: (captcha: string | null) => void;
  onMount: () => void;
  showBox?: boolean;
};

const captchaCss = (props: CaptchaProps) =>
  css(
    {
      background: Colors.white,
    },
    props.showBox && {
      borderRadius: 4,
      boxShadow:
        '0 0 1px rgba(95, 108, 114, 0.08), 0 2px 18px rgba(95, 108, 114, 0.18)',
      marginBottom: 15,
    }
  );

const descriptionCss: Interpolation = {
  fontSize: 16,
  marginBottom: 24,
  textAlign: 'center',
};

const recaptchaCss = {
  display: 'flex',
  justifyContent: 'center',
  marginTop: 30,
};

const Captcha = (props: CaptchaProps) => {
  // Call onMount when this mounts
  useEffect(() => {
    if (props.onMount) {
      props.onMount();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div css={captchaCss(props)}>
      <div css={descriptionCss}>
        Looks like our robots want to make sure you’re not one!
      </div>
      <ReCAPTCHA
        css={recaptchaCss}
        onChange={props.onCaptchaVerification}
        onExpired={props.onCaptchaExpiration}
        sitekey={props.googleCaptchaSiteKey}
      />
    </div>
  );
};

export default Captcha;
